import { Module } from 'vuex'

interface NotificationState {
  errors: string[]
}

const notificationStore: Module<NotificationState, any> = {
  namespaced: true,

  state: (): NotificationState => ({
    errors: [],
  }),

  mutations: {
    SET_ERRORS(state, messages: string[]) {
      state.errors = messages
    },

    CLEAR_ERRORS(state) {
      state.errors = []
    },
  },

  actions: {
    setErrors({ commit }, messages: string[]) {
      commit('SET_ERRORS', messages)
    },

    clearErrors({ commit }) {
      commit('CLEAR_ERRORS')
    },
  },
}

export default notificationStore
